import React from 'react';

export default function ServiceLandingPageskeleton() {
  return (
    <div>
      <div className="max-w-5xl mx-auto space-y-8 px-4 sm:px-6">
        {/* Hero skeleton */}
        <div className="relative overflow-hidden rounded-[28px] bg-gradient-to-br from-purple-100 via-indigo-50 to-blue-50 p-10 h-[280px]">
          <div className="animate-pulse space-y-4">
            <div className="flex gap-3">
              <div className="h-6 w-24 bg-white/60 rounded-full" />
              <div className="h-6 w-20 bg-white/60 rounded-full" />
            </div>
            <div className="h-8 w-72 bg-white/50 rounded-xl mt-4" />
            <div className="h-5 w-96 bg-white/40 rounded-lg" />
            <div className="h-12 w-40 bg-white/50 rounded-xl mt-4" />
          </div>
          <div className="absolute -bottom-8 -right-8 w-40 h-40 rounded-full bg-white/10" />
          <div className="absolute top-4 right-12 w-20 h-20 rounded-full bg-white/10" />
        </div>
        {/* Content skeletons */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {[0, 1, 2].map(i => (
            <div
              key={i}
              className="animate-pulse bg-white rounded-2xl p-6 h-28 shadow-sm"
            >
              <div className="h-4 w-20 bg-gray-100 rounded-lg mb-3" />
              <div className="h-6 w-16 bg-gray-100 rounded-lg" />
            </div>
          ))}
        </div>
        <div className="animate-pulse bg-white rounded-2xl p-8 h-48 shadow-sm" />
        <div className="animate-pulse bg-white rounded-2xl p-8 h-40 shadow-sm" />
      </div>
    </div>
  );
}
